declare global {
  interface Window {
    RaisinMobile?: {
      openAssetViewer: (url: string, mimeType: string) => void;
      shareToken: (token: string) => void;
      logout: () => void;
    };
  }
}
export const buildPdf = (base64Content: string): string | void => {
  // pre-login
  // It is necessary to create a new blob object with mime-type explicitly set
  // otherwise only Chrome works like it should
  // encode base64 to byte format for blob
  const convertDataToBinary = (data: string) => {
    const raw = atob(data);
    const rawLength = raw.length;
    const array = new Uint8Array(new ArrayBuffer(rawLength));
    for (let i = 0; i < rawLength; i++) {
      array[i] = raw.charCodeAt(i);
    }
    return array;
  };

  const byteCharacters = convertDataToBinary(base64Content);

  const newBlob = new Blob([byteCharacters], { type: 'application/pdf' });
  const nav = window.navigator as any;

  // IE doesn't allow using a blob object directly as link href (it is necessary to use msSaveOrOpenBlob)
  if (nav && nav.msSaveOrOpenBlob) {
    nav.msSaveOrOpenBlob(newBlob);
  }

  // for mobile app until they have api call for the documents
  if (window?.RaisinMobile && localStorage.getItem('mobileApp') === 'true') {
    window?.RaisinMobile?.openAssetViewer(base64Content, 'application/pdf');
  } else {
    return URL.createObjectURL(newBlob);
  }
};
